import React from 'react'
import PropTypes from 'prop-types'

const TermFormat = ({ data }) => {
  if (!data) {
    return '-'
  }

  const formats = {
    1: '1 month',
    12: '1 year',
    24: '2 years',
    36: '3 years'
  }

  return <span>{formats[data]}</span>
}

TermFormat.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default TermFormat
